import { render, staticRenderFns } from "./RecipeCmsPage.vue?vue&type=template&id=5d24f312&scoped=true&"
import script from "./RecipeCmsPage.vue?vue&type=script&lang=js&"
export * from "./RecipeCmsPage.vue?vue&type=script&lang=js&"
import style0 from "./RecipeCmsPage.vue?vue&type=style&index=0&id=5d24f312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d24f312",
  null
  
)

export default component.exports